import React from "react";
import { useWeb3 } from "../context/Web3Context";
import { useToast } from "./common/Toast";
import { parseError } from "../utils/errors";
import { APP_NAME } from "../config/app.config";
import Icon from "./common/Icon";

const POINTS = [
  { icon: "coins", title: "Sell SCN or CORE → USDT", text: "Swap your SCN or CORE tokens for USDT in one transaction." },
  { icon: "shield", title: "Vault-backed price", text: "Payout comes from each token's on-chain USDT liquidity vault at the live price." },
  { icon: "spark", title: "Holder-friendly", text: "A 10% sell fee stays in the vault as liquidity, supporting the price." },
];

export default function ConnectWallet() {
  const { connect, connecting, hasWallet } = useWeb3();
  const toast = useToast();

  const onConnect = async () => {
    if (!hasWallet) {
      toast.error("No wallet detected. Open this page in Trust Wallet / MetaMask in-app browser.");
      return;
    }
    try {
      await connect();
      toast.success("Wallet connected.");
    } catch (e) {
      toast.error(parseError(e));
    }
  };

  return (
    <main className="app-content">
      <div className="stack">
        <div className="hero hero-anim center fade-up">
          <img src="/logo.png" alt={APP_NAME} className="connect-logo" />
          <h1 style={{ margin: "6px 0 4px" }}>{APP_NAME}</h1>
          <p className="muted" style={{ marginTop: 4 }}>Swap SCN &amp; CORE for USDT — fast, on-chain, vault-backed.</p>
          <button className="btn btn-block mt-4" onClick={onConnect} disabled={connecting}>
            {connecting ? "Connecting…" : "Connect Wallet"}
          </button>
        </div>

        <div className="card">
          <div className="section-title">How the swap works</div>
          <div className="stack">
            {POINTS.map((p) => (
              <div className="row" key={p.title} style={{ gap: 12, alignItems: "flex-start" }}>
                <span className="dex-note-ico"><Icon name={p.icon} size={18} /></span>
                <div>
                  <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14 }}>{p.title}</div>
                  <div className="muted" style={{ fontSize: 12.5, lineHeight: 1.5 }}>{p.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
